// extracted by mini-css-extract-plugin
export var contentCard = "bC_fg";
export var gridBase = "bC_fc";
export var gridElement = "bC_fh";
export var gridTumbleIn = "bC_fj";
export var heightAuto = "bC_ff";
export var heightFull = "bC_fd";